import { useSelector } from 'react-redux'
import { getKioskBarcodeScanningEnabled } from '../../selectors/config'

/**
 * KioskPrompt component for displaying the prompt message in the attract loop.
 *
 * @param {boolean} param.scanningEnabled - Flag indicating if scanning is enabled.
 * @returns {JSX.Element}
 */
const KioskPrompt = () => {
  const scanningEnabled = useSelector(getKioskBarcodeScanningEnabled)

  if (scanningEnabled) {
    return (
      <div className="attract-loop__center">
        <div className="attract-loop__cta">Pay</div>
        <div className="attract-loop__cta -large">Here</div>
        <div className="attract-loop__cta -xsmall">Tap screen or scan item to start</div>
      </div>
    )
  }

  return (
    <div className="attract-loop__center">
      <div className="attract-loop__cta">Order</div>
      <div className="attract-loop__cta -large">Now</div>
      <div className="attract-loop__cta -small">Tap screen to start</div>
    </div>
  )
}

export default KioskPrompt
